import React from 'react';
import { RouteFormatter } from '../routes';
import dogFencedImg from '../assets/img/spot-types/dog-fully-fenced.png';
import dogHikingImg from '../assets/img/spot-types/dog-hiking.png';
import dogIndoorImg from '../assets/img/spot-types/dog-indoor.png';
import dogWaterImg from '../assets/img/spot-types/dog-water-park.png';
import dogBeachImg from '../assets/img/spot-types/dog-beach.png';
import dogFieldImg from '../assets/img/spot-types/dog-field.png';
import dogSmallImg from '../assets/img/spot-types/dog-small.png';
import dogPoolImg from '../assets/img/spot-types/dog-pool.png';
import dogAgiImg from '../assets/img/spot-types/dog-agility.png';
import {
    SvgAmenitiesAgilityEquipment,
    SvgAmenitiesBeach,
    SvgAmenitiesField,
    SvgAmenitiesHill,
    SvgAmenitiesIndoor,
    SvgAmenitiesKiddiePool,
    SvgAmenitiesSmallDog,
    SvgAmenitiesSwimmingPool,
} from '../components/svg/amenities';
import SvgFenced from 'src/assets/svg/SvgFenced.svg';

export const otherSubs = [
    {
        id: 'WATER',
        icon: <SvgAmenitiesKiddiePool />,
        img: dogWaterImg,
        title: 'Dog water parks',
        desc: 'Many hosts have added water features like pools and/or are nearby lakes or rivers.',
        link: RouteFormatter.waterListings(),
    },
    {
        id: 'HIKING',
        icon: <SvgAmenitiesHill />,
        img: dogHikingImg,
        title: 'Dog hiking trails',
        desc: 'Some of our best spots have hiking trails in wonderful natural settings.',
        link: RouteFormatter.hikingListings(),
    },
    {
        id: 'INDOOR',
        icon: <SvgAmenitiesIndoor />,
        img: dogIndoorImg,
        title: 'Indoor dog parks',
        desc: 'A good alternative to do activities with your dogs on a rainy day and unpleasant weather in general.',
        link: RouteFormatter.indoorListings(),
    },
    {
        id: 'FENCED',
        icon: <SvgFenced />,
        img: dogFencedImg,
        title: 'Fully fenced dog parks',
        desc: 'Very popular choice, perfect to contain your dogs if they are escape artists or if they are not good at recall.',
        link: RouteFormatter.fencedListings(),
    },
    {
        id: 'BEACH',
        icon: <SvgAmenitiesBeach />,
        img: dogBeachImg,
        title: 'Dog beaches',
        desc: 'Some spots are conveniently located by the sea or have sand and other beach features.',
        link: RouteFormatter.beachListings(),
    },
    {
        id: 'AGILITY',
        icon: <SvgAmenitiesAgilityEquipment />,
        img: dogAgiImg,
        title: 'Dog agility parks',
        desc: 'Some hosts have implemented full agility courses to train your dogs in a private environment.',
        link: RouteFormatter.agilityListings(),
    },
    {
        id: 'FIELDS',
        icon: <SvgAmenitiesField />,
        img: dogFieldImg,
        title: 'Dog fields',
        desc: 'Many of the listed spots are large pastures, fields and have farm animals that can be sighted.',
        link: RouteFormatter.fieldsListings(),
    },
    {
        id: 'SMALL',
        icon: <SvgAmenitiesSmallDog />,
        img: dogSmallImg,
        title: 'Small dog parks',
        desc: 'Dog parks that specifically work for the needs of dogs that are smaller in size.',
        link: RouteFormatter.smallDogListings(),
    },
    {
        id: 'POOL',
        icon: <SvgAmenitiesSwimmingPool />,
        img: dogPoolImg,
        title: 'Dog swimming pools',
        desc: 'Many spots feature private swimming pools, perfect for dogs to enjoy and play.',
        link: RouteFormatter.poolListings(),
    },
];
